/**
 * Format a date as "MMM yyyy" or "MMMM, yyyy". Returns empty for invalid/ancient dates (year < 1900).
 */
export const formatMonthYear = (
  value: string | number | Date | null | undefined,
  options?: { longMonth?: boolean }
): string => {
  if (value == null) return ''
  const date = typeof value === 'object' ? value : new Date(value)
  if (Number.isNaN(date.getTime())) return ''
  const year = date.getUTCFullYear()
  if (year < 1900 || year > 2100) return ''
  return date.toLocaleDateString('en-US', {
    month: options?.longMonth ? 'long' : 'short',
    year: 'numeric',
    timeZone: 'UTC',
  })
}

const supportTimeZone = 'Europe/London'

export const formatDate = (dateString: string) => {
  const date = new Date(dateString)
  return date
    .toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      timeZone: supportTimeZone,
    })
    .replace(/ /g, '-')
}

export const formatTime = (dateString: string) => {
  const date = new Date(dateString)
  return date.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
    timeZone: supportTimeZone,
  })
}
